// Generated by ReScript, PLEASE EDIT WITH CARE


let fieldHeight = "1.8rem";

let reservedBoxHeight = `calc(` + fieldHeight + ` + 4px)`;

export {
  fieldHeight,
  reservedBoxHeight,
}
/* No side effect */
